export interface MedicalJournalShortDto {
    id: number;
    companyName: string;
    signedByFio: string;
    createdDate: Date;
    createdByFio: string;
    status: MedicalJournalStatus;
    signedDate?: Date;
  }

export enum MedicalJournalStatus {
    Unsigned = "Unsigned",
    Signing = "Signing", 
    Signed = "Signed",
    SigningError = "SigningError"
}

export const MedicalJournalStatusUtil = {
    getStringValue: (status: MedicalJournalStatus): string => {
        switch (status) {
            case MedicalJournalStatus.Unsigned:
                return "Не подписан";
            case MedicalJournalStatus.Signing:
                return "Идет подписание";
            case MedicalJournalStatus.Signed:
                return "Подписан";
            case MedicalJournalStatus.SigningError:
                return "Ошибка подписания";
            default:
                return "Неизвестно";
        }
    }
}
  